module.exports = __webpack_public_path__ + "img/Gut_dna.6edbd5c4.png";